import React, {useEffect, useState} from "react";
import {BusinnesWrap} from "components/atoms/BusinessSetup/BusinessSetup.styles";
import Form from "components/molecules/Form/Form";
import Field from "components/molecules/Field";
import Button from "components/molecules/Button";
import {useForm} from "components/molecules/Form";
import Heading from "components/atoms/Auth/Heading";
import {useDispatch} from "react-redux";
import {useSelector} from "react-redux";
import {setBusinessSetup4} from "store/reducers/businessSlice";
import CenterModal from "components/molecules/Modal/CenterModal";
import ItemPreviewModal from "../MenuManagement/ItemPreviewModal";

const LegalStuff = ({setFormData, setCurrentStep, currentStep, totalSteps, prevData}) => {
    const [form] = useForm();
    const dispatch = useDispatch();
    const {businessSetup4} = useSelector(state => state.business);
    const [selectedTaxInfo, setSelectedTaxInfo] = useState({
        label: "Tax Included",
        value: true,
    });
    const [radio, setRadio] = useState({
        license: true,
        stock: false,
        country: true,
        revenue: false,
    });
    const taxInfoData = [
        {label: "Tax Included", value: true},
        {label: "Tax Excluded", value: false},
    ];
    const proofIdData = [{label: "CNIC Number", value: "CNIC Number"}];

    useEffect(() => {
        if (Object.keys(prevData).length > 0 && currentStep === 2) {
            if (!prevData.tax_included) {
                setSelectedTaxInfo({label: "Tax Excluded", value: false});
            }
            form.setFieldsValue({tax_number: prevData.tax_number, cnic_number: prevData.cnic_number});
            setRadio({
                license: prevData.operating_license,
                stock: prevData.stock_exchange_list,
                // country: prevData.sanctioned_country_list,
                revenue: false,
            });
            if (prevData?.cnic_number) {
                form.setFieldsValue({
                    proof_id: {label: "CNIC Number", value: "CNIC Number"},
                });
            }
        }
    }, [prevData, currentStep, form]);

    function handleSubmit(e) {
        const stepFour = {
            tax_info: selectedTaxInfo.label,
            tax_number: e.tax_number || "",
            cnic_number: e.cnic_number || "",
            proofType: e?.proof_id,
            operating_license: radio.license,
            stock_exchange_list: radio.stock,
            // sanctioned_country_list: radio.country,
        };

        dispatch(setBusinessSetup4(stepFour));
        setFormData(prev => ({...prev, step4: {...stepFour}}));
        setCurrentStep(5);
    }

    useEffect(() => {
        if (businessSetup4 && Object.keys(businessSetup4).length > 0) {
            form.setFieldsValue({
                tax_number: businessSetup4?.tax_number,
                cnic_number: businessSetup4?.cnic_number,
                proof_id: proofIdData?.find(data => data.value === businessSetup4?.proofType?.value),
            });
            setRadio({
                license: businessSetup4?.operating_license,
                stock: businessSetup4?.stock_exchange_list,
            });
            setSelectedTaxInfo(taxInfoData?.find(data => data.label === businessSetup4?.tax_info));
        }
    }, [businessSetup4, form]);

    return (
        <BusinnesWrap>
            <Heading heading="Provide" ColoredText="Legal Stuff!" para="We need to verify your business." />
            <Form form={form} onSubmit={handleSubmit}>
                <Form.Item
                    label="Business Number*"
                    type="text"
                    rounded
                    name="business_number"
                    lg
                    placeholder="Enter Business Number"
                    $bgWhite
                    rules={[
                        {
                            required: true,
                            message: "Business number is required",
                        },
                    ]}>
                    <Field />
                </Form.Item>

                <Form.Item
                    label="GST/HST Registration Number"
                    type="text"
                    rounded
                    name="registration_number"
                    lg
                    placeholder="Enter Registration Number"
                    $bgWhite>
                    <Field />
                </Form.Item>

                {/* <Form.Item
                    label="Tax Type"
                    type="select"
                    rounded
                    name="tax_type"
                    lg
                    placeholder="Select Tax Type"
                    options={taxInfoData}
                    $bgWhite>
                    <Field />
                </Form.Item> */}

                {/* {selectedTaxInfo.value === true && (
                    <>
                        <Form.Item
                            label="Tax Number *"
                            type="number"
                            min={0}
                            rounded
                            name="tax_number"
                            lg
                            placeholder="21356425894588"
                            $bgWhite
                            rules={[
                                {
                                    required: true,
                                    message: "Tax number is required",
                                },
                            ]}>
                            <Field />
                        </Form.Item>
                        <div className="signup-fields">
                            <Form.Item
                                label="ID Proof Type *"
                                type="select"
                                rounded
                                name="proof_id"
                                lg
                                placeholder="ID"
                                $bgWhite
                                options={proofIdData}
                                rules={[
                                    {
                                        required: true,
                                        message: "Proof ID is required",
                                    },
                                ]}>
                                <Field />
                            </Form.Item>
                            <Form.Item
                                label="Enter CNIC Number *"
                                type="text"
                                rounded
                                name="cnic_number"
                                lg
                                placeholder="3540275500387"
                                $bgWhite
                                rules={[
                                    {
                                        required: true,
                                        message: "id number is required",
                                    },
                                ]}>
                                <Field />
                            </Form.Item>
                        </div>
                    </>
                )} */}
                <div className="upload-wrap">
                    <Form.Item
                        type="img"
                        label="Operating License (Upload)*"
                        $bgWhite
                        rounded
                        lg
                        name="operatingLicense"
                        uploadTitle="Upload Restaurant Operating License"
                        disc="Upload Document"
                        rules={[
                            {
                                required: true,
                                message: "License is required",
                            },
                        ]}>
                        <Field />
                    </Form.Item>
                </div>
                {/* <p>Do you have an operating license?</p>
                <div className="questions">
                    <Form.Item
                        label="Yes"
                        type="radio"
                        name="operating_license_y"
                        value={radio.license === true}
                        onChange={() => setRadio(prev => ({...prev, license: true}))}>
                        <Field />
                    </Form.Item>
                    <Field
                        label="No"
                        type="radio"
                        name="operating_license_n"
                        value={radio.license === false}
                        onChange={() => setRadio(prev => ({...prev, license: false}))}
                    />
                </div>
                <p>Is your business part of listed company in stock exchange?</p>
                <div className="questions">
                    <Field
                        label="Yes"
                        type="radio"
                        name="stock_y"
                        value={radio.stock === true}
                        onChange={() => setRadio(prev => ({...prev, stock: true}))}
                    />
                    <Field
                        label="No"
                        type="radio"
                        name="stock_n"
                        value={radio.stock === false}
                        onChange={() => setRadio(prev => ({...prev, stock: false}))}
                    />
                </div> */}
                {/* <p>
                    Is your business registered under any one of the sanctioned <br /> country ?
                </p>
                <div className="questions">
                    <Field
                        label="Yes"
                        type="radio"
                        name="country_y"
                        value={radio.country === true}
                        onChange={() => setRadio(prev => ({...prev, country: true}))}
                    />
                    <Field
                        label="No"
                        type="radio"
                        name="country_n"
                        value={radio.country === false}
                        onChange={() => setRadio(prev => ({...prev, country: false}))}
                    />
                </div>
                <p>
                    Is your business registered with Pakistan's Federal Bureau of <br /> Revenue ?
                </p>
                <div className="questions">
                    <Field
                        label="Yes"
                        type="radio"
                        name="revenue_y"
                        value={radio.revenue === true}
                        onChange={() => setRadio(prev => ({...prev, revenue: true}))}
                    />
                    <Field
                        label="No"
                        type="radio"
                        name="revenue_n"
                        value={radio.revenue === false}
                        onChange={() => setRadio(prev => ({...prev, revenue: false}))}
                    />
                </div> */}
                <div className="btn-holder">
                    <Button lg disabled={currentStep === totalSteps}>
                        Next
                    </Button>
                </div>
            </Form>
        </BusinnesWrap>
    );
};

export default LegalStuff;
